import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useVoteRoomPrecheckConfirmParams(): {
  analysisId: string;
  shareholderId: string;
  token: string;
} | null {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const analysisId = searchParams.get('analysisId')?.trim() ?? '';
    const shareholderId = searchParams.get('shareholderId')?.trim() ?? '';
    const token = searchParams.get('token')?.trim() ?? '';
    if (!analysisId || !shareholderId || !token) {
      return null;
    }
    return { analysisId, shareholderId, token };
  }, [searchParams]);
}
